export interface Position {
  gpslaenge: number;
  gpsbreite: number;
  gpshoehe?: number;
  genauigkeit?: number;
  genauigkeithoehe?: number;
  geschwindigkeit?: number;
  richtung?: number;
}
